<style>

  ::ng-deep .attendanceDateChange .mat-form-field-appearance-outline .mat-form-field-outline {
      background-color: #ffff8d;;
  }
</style>

<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
  <div class="flex-header">
    <page-header pageTitle="Check In/Check Out" class="flex-header"></page-header>
  </div>

  <div class="flex-content" style="height: 100%;">
    <form id="attendanceByClassControls" (keydown)="keyDownFunction($event)" class="side-padding">
      <div style="display: flex;flex-direction: row;">
        <div style="padding-left: 10px;" [ngClass]="{'attendanceDateChange': !sameDate}">
          <tyl-datepicker #datAttendanceDateRef id="attendanceDateRef" name="attendanceDateRef" (valueChange) = "dateChange($event)"
            (dateInputChange)="datAttendanceDate = $event" [isRequired]="true" [(value)]="attendanceDate"
            style="width: 170px;" tabindex="-1" label="Attendance Date">
          </tyl-datepicker>
        </div>

        <div style="padding-left: 20px;padding-top: 5px;width: 80%;">
          <mat-chip-list #control id="chipList">
            <!-- Completed -->
            <mat-chip id="chipCompletedSelected" selected (click)="displayChange('completed')"
              [ngClass]="includeCompleted ? 'chip-without-hover-Selected' : 'chip-without-hover-NotSelected'">
              <img src="./assets/images/checkmarkwhitenocircle.png" *ngIf="includeCompleted" class="small-check">
              Completed
            </mat-chip>

            <!-- Submitted -->
            <mat-chip id="chipSubmittedSelected" selected (click)="displayChange('submitted')"
              [ngClass]="includeSubmitted ? 'chip-without-hover-Selected' : 'chip-without-hover-NotSelected'">
              <img src="./assets/images/checkmarkwhitenocircle.png" *ngIf="includeSubmitted" class="small-check">
              Submitted
            </mat-chip>
          </mat-chip-list>
        </div>

        <div style="padding-left: 20px;padding-top: 5px;">
          <button mat-button (click)="searchClick()">Search</button>
        </div>
      </div>
    </form>

    <div style="text-align:center;" *ngIf="angularMatData.data.length == 0">
      No record exists for selected Date
    </div>

    <div *ngIf="angularMatData.data.length > 0">
      <mat-table #table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="Time"
        matSortDirection="asc">

        <!-- Type -->
        <ng-container matColumnDef='Type'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Type">Type
            <filter class="mat-filter" [data]="angularMatData" columnName="Type" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Type}}</mat-cell>
        </ng-container>

        <!-- Time -->
        <ng-container matColumnDef='Time'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Time">
            Time
            <filter class="mat-filter" [data]="angularMatData" columnName="Time" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Time}}</mat-cell>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef='Status'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Status">
            Status
            <filter class="mat-filter" [data]="angularMatData" columnName="Status" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Status}}</mat-cell>
        </ng-container>

        <!-- StudentNumber -->
        <ng-container matColumnDef='StudentNumber'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="StudentNumber">
            Student #
            <filter class="mat-filter" [data]="angularMatData" columnName="StudentNumber" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.StudentNumber}}</mat-cell>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef='Name'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Name">
            Name
            <filter class="mat-filter" [data]="angularMatData" columnName="Name" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <a #studentName class="link"
              (click)="studentInfoClick(st); $event.stopPropagation();">
              <student-name [firstName]="st.StudentFirstName" [lastName]='st.StudentLastName'
                [middleName]='st.StudentMiddleName'></student-name>
            </a>
          </mat-cell>
        </ng-container>

        <!-- Period -->
        <ng-container matColumnDef='Period'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Period">
            Period
            <filter class="mat-filter" [data]="angularMatData" columnName="Period" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Period}}</mat-cell>
        </ng-container>

        <!-- LEMinutes -->
        <ng-container matColumnDef='LEMinutes'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Minutes">
            L/E Minutes
            <filter class="mat-filter" [data]="angularMatData" columnName="Minutes" dataType="number"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Minutes}}</mat-cell>
        </ng-container>

        <!-- Attachment -->
        <ng-container matColumnDef='Attachment'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Attachment">
            <img src="./assets/images/paperclip.png" alt="paperclip" style="height: 20px" />
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <a *ngIf="st.Attachment" class="link" (click)="viwAttachments(st)">Y</a>
            <span *ngIf="!st.Attachment"></span>
          </mat-cell>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef class="print-ignore">Actions
          </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index;" class="print-ignore">
            <tyl-mat-menu *ngIf="element.Status == 'Completed'" id="actionMenu{{i}}" image="actions.png">
              <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="editClick(element)">
                Edit
              </button>
              <mat-divider>
              </mat-divider>
              <button id="addAttachment{{i}}" mat-menu-item class="menuItem" (click)="addAttachmentClick(element.HistoryId)">
                Add Attachment
              </button>
              <button id="viewHistory{{i}}" mat-menu-item class="menuItem" (click)="viewHistoryClick(element.StudentId)">
                View History
              </button>
              <mat-divider>
              </mat-divider>
              <button id="inacdeletetivate{{i}}" mat-menu-item class="menuItem" (click)="deleteClick(element.HistoryId, 'history')">
                Delete
              </button>
            </tyl-mat-menu>

            <tyl-mat-menu *ngIf="element.Status == 'Submitted'" id="actionMenu{{i}}" image="actions.png">
              <button id="process{{i}}" mat-menu-item class="menuItem" (click)="processClick(element)">
                Process
              </button>
              <mat-divider>
              </mat-divider>
              <button id="inacdeletetivate{{i}}" mat-menu-item class="menuItem" (click)="deleteClick(element.SubmissionId, 'submission')">
                Delete
              </button>
            </tyl-mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"
          style="position:sticky;top:0;z-index:100;background:white;border-top-style: solid;border-top-color: lightgray;border-top-width: thin;padding:0px;">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;"
          style="padding:0px;align-items: start;overflow: hidden;">
        </mat-row>
      </mat-table>
    </div>
  </div>
</tyl-kendo-pdf-export>

<div #footer class="flex-footer">
  <div class="flex-footer-left">
    <tyl-button image="Legend.png" label="Legend" (click)="legendClick()"></tyl-button>
    <tyl-button image="check in.png" label="Check In" (click)="checkInOutClick('Check In')"></tyl-button>
    <tyl-button image="check out.png" label="Check Out" (click)="checkInOutClick('Check Out')"></tyl-button>
    <tyl-button image="help black.png" label="How To" (click)="howToClick()"></tyl-button>
  </div>
  <div class="flex-footer-middle">

  </div>
  <div class="flex-footer-right">
    <error-prompt [errorList]="errors"></error-prompt>
  </div>
</div>
